/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useEffect, useRef } from 'react';

const Modal = ({ children, onClose, labelledById, width = 'md' }) => {
  const dialogRef = useRef(null);

  useEffect(() => {
    if (dialogRef.current) dialogRef.current.focus();
  }, []);

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [onClose]);

  // Mappning av width-prop till Tailwind-klasser
  const widthClasses = {
    xs: 'tw-w-[16rem]', 
    sm: 'tw-w-[24rem]',  // ca 24rem
    md: 'tw-w-[32rem]', // ca 512px
    lg: 'tw-w-[48rem]', // ca 768px
    xl: 'tw-w-[64rem]',  // ca 1024px
    xxl: 'tw-w-[96rem]'  
  };

  const appliedWidthClass = widthClasses[width] || widthClasses.md;

  return (
    <div
      className="tw-fixed tw-inset-0 tw-bg-black tw-bg-opacity-50 tw-flex tw-items-center tw-justify-center tw-z-50 tw-overflow-auto"
      onClick={onClose}
      tabIndex={-1}
      role="presentation"
    >
      <div
        className={`tw-bg-white tw-rounded-2xl tw-shadow-2xl tw-relative tw-p-6 tw-flex tw-gap-6 ${appliedWidthClass}`}
        onClick={(e) => e.stopPropagation()}
        ref={dialogRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby={labelledById}
        onKeyDown={(e) => {
          if (e.key === 'Escape' || e.key === ' ') {
            e.preventDefault();
            onClose();
          }
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default Modal;
